
import { MessageSquare, Star, TrendingUp, CheckCircle2 } from "lucide-react";

interface EnquiryStatsProps {
  totalCount: number;
  newCount: number;
  qualifiedCount: number;
  convertedCount: number;
}

export default function EnquiryStats({
  totalCount,
  newCount,
  qualifiedCount,
  convertedCount,
}: EnquiryStatsProps) {
  const stats = [
    { label: "Total", count: totalCount, icon: MessageSquare, color: "text-blue-600", bg: "bg-blue-50" },
    { label: "New", count: newCount, icon: Star, color: "text-amber-600", bg: "bg-amber-50" },
    { label: "Qualified", count: qualifiedCount, icon: TrendingUp, color: "text-purple-600", bg: "bg-purple-50" },
    { label: "Converted", count: convertedCount, icon: CheckCircle2, color: "text-emerald-600", bg: "bg-emerald-50" },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
      {stats.map((stat, idx) => {
        const Icon = stat.icon;
        return (
          <div key={idx} className="bg-white rounded-xl p-4 border border-stone-100 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${stat.bg}`}>
                <Icon className={`w-5 h-5 ${stat.color}`} />
              </div>
              <div>
                <div className="text-2xl font-bold text-stone-900">{stat.count}</div>
                <div className="text-xs font-medium text-stone-500">{stat.label}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
